import { r as Pt, c as l, a as ut, h as a, g as ft, o as dt } from "./main-bb89b2f2.js";
import { T as h } from "./translation-service-06f7c8c7-b6396601.js";
import "vue";
const u = "Erste Seite", f = "Zurück", d = "Weiter", x = "Letzte Seite", xt = {
  firstPage: u,
  previousPage: f,
  nextPage: d,
  lastPage: x
}, bt = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  firstPage: u,
  previousPage: f,
  nextPage: d,
  lastPage: x,
  default: xt
}), b = "First Page", v = "Previous Page", w = "Next Page", m = "Last Page", vt = {
  firstPage: b,
  previousPage: v,
  nextPage: w,
  lastPage: m
}, wt = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  firstPage: b,
  previousPage: v,
  nextPage: w,
  lastPage: m,
  default: vt
}), y = "Primera Página", S = "Página Anterior", _ = "Página Siguiente", $ = "Última Página", mt = {
  firstPage: y,
  previousPage: S,
  nextPage: _,
  lastPage: $
}, yt = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  firstPage: y,
  previousPage: S,
  nextPage: _,
  lastPage: $,
  default: mt
}), k = "Première Page", z = "Page Précédente", j = "Page Suivante", D = "Dernière Page", St = {
  firstPage: k,
  previousPage: z,
  nextPage: j,
  lastPage: D
}, _t = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  firstPage: k,
  previousPage: z,
  nextPage: j,
  lastPage: D,
  default: St
}), B = "Prima Pagina", L = "Pagina Precedente", C = "Pagina Successiva", O = "Ultima Pagina", $t = {
  firstPage: B,
  previousPage: L,
  nextPage: C,
  lastPage: O
}, kt = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  firstPage: B,
  previousPage: L,
  nextPage: C,
  lastPage: O,
  default: $t
}), T = "最初のページ", I = "前のページ", J = "次のページ", R = "最後のページ", zt = {
  firstPage: T,
  previousPage: I,
  nextPage: J,
  lastPage: R
}, jt = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  firstPage: T,
  previousPage: I,
  nextPage: J,
  lastPage: R,
  default: zt
}), U = "첫 페이지", M = "이전 페이지", N = "다음 페이지", E = "마지막 페이지", Dt = {
  firstPage: U,
  previousPage: M,
  nextPage: N,
  lastPage: E
}, Bt = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  firstPage: U,
  previousPage: M,
  nextPage: N,
  lastPage: E,
  default: Dt
}), A = "Eerste Pagina", F = "Vorige Pagina", q = "Volgende Pagina", H = "Laatste Pagina", Lt = {
  firstPage: A,
  previousPage: F,
  nextPage: q,
  lastPage: H
}, Ct = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  firstPage: A,
  previousPage: F,
  nextPage: q,
  lastPage: H,
  default: Lt
}), V = "Pierwsza Strona", W = "Poprzednia Strona", Z = "Następna Strona", G = "Ostatnia Strona", Ot = {
  firstPage: V,
  previousPage: W,
  nextPage: Z,
  lastPage: G
}, Tt = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  firstPage: V,
  previousPage: W,
  nextPage: Z,
  lastPage: G,
  default: Ot
}), K = "Primeira Página", Q = "Página Anterior", X = "Próxima Página", Y = "Última Página", It = {
  firstPage: K,
  previousPage: Q,
  nextPage: X,
  lastPage: Y
}, Jt = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  firstPage: K,
  previousPage: Q,
  nextPage: X,
  lastPage: Y,
  default: It
}), tt = "Первая страница", et = "Предыдущая страница", at = "Следующая страница", it = "Последняя страница", Rt = {
  firstPage: tt,
  previousPage: et,
  nextPage: at,
  lastPage: it
}, Ut = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  firstPage: tt,
  previousPage: et,
  nextPage: at,
  lastPage: it,
  default: Rt
}), st = "İlk Sayfa", nt = "Önceki Sayfa", ot = "Sonraki Sayfa", rt = "Son Sayfa", Mt = {
  firstPage: st,
  previousPage: nt,
  nextPage: ot,
  lastPage: rt
}, Nt = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  firstPage: st,
  previousPage: nt,
  nextPage: ot,
  lastPage: rt,
  default: Mt
}), lt = "第一页", gt = "上一页", ct = "下一页", pt = "最后一页", Et = {
  firstPage: lt,
  previousPage: gt,
  nextPage: ct,
  lastPage: pt
}, At = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  firstPage: lt,
  previousPage: gt,
  nextPage: ct,
  lastPage: pt,
  default: Et
}), Ft = "*,:after,:before{border-color:var(--color-neutral-steel-200);border-style:solid;border-width:0;box-sizing:border-box}a{color:inherit;text-decoration:inherit}audio,canvas,embed,iframe,img,object,svg,video{display:block;vertical-align:middle}button,input,optgroup,select,textarea{font-feature-settings:inherit;color:inherit;font-family:inherit;font-size:100%;font-variation-settings:inherit;font-weight:inherit;letter-spacing:inherit;line-height:inherit;margin:0;padding:0}blockquote,dd,dl,fieldset,figure,h1,h2,h3,h4,h5,h6,hr,p,pre{margin:0}fieldset,legend{padding:0}.ml-\\[24px\\]{margin-left:24px}.mr-\\[12px\\]{margin-right:12px}.ml-0{margin-left:var(--spacing-0)}.flex{display:flex}.contents{display:contents}.h-\\[48px\\]{height:48px}.w-\\[48px\\]{width:48px}.cursor-pointer{cursor:pointer}.flex-wrap{flex-wrap:wrap}.flex-wrap-reverse{flex-wrap:wrap-reverse}.items-center{align-items:center}.justify-center{justify-content:center}.justify-between{justify-content:space-between}.gap-\\[10px\\]{gap:10px}.truncate{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.border-0{border-width:0}.bg-transparent{background-color:transparent}.pl-\\[12px\\]{padding-left:12px}.pr-\\[12px\\]{padding-right:12px}.font-text{font-family:var(--copytext-font-family)}.text-copy-uniform{font-size:var(--copytext-font-size-noctx);line-height:var(--copytext-line-height-noctx)}.text-copy-small-uniform{font-size:var(--copytext-font-size-small-noctx);line-height:var(--copytext-line-height-small-noctx)}.outline-none{outline:2px solid transparent;outline-offset:2px}:host{display:contents}.pagination-wrapper{align-items:center;display:flex;flex-wrap:wrap-reverse;font-size:var(--copytext-font-size-noctx);gap:10px;justify-content:center;line-height:var(--copytext-line-height-noctx);width:100%}.pagination-pages,.pagination-pages .pagination-page-placeholder{align-items:center;display:flex;justify-content:space-between}.pagination-pages .pagination-page-placeholder .pagination-dot-placeholder{font-family:var(--copytext-font-family-bold);margin:0 2px}.row-info-slots-wrapper ::slotted([slot=dropdown]){flex-shrink:0}.row-info-slots-wrapper ::slotted([slot=dropdown-label]){color:var(--pagination-text-label);font-size:var(--copytext-font-size-small-noctx);line-height:var(--copytext-line-height-small-noctx);overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.row-info-slots-wrapper ::slotted([slot=dropdown-range-label]){color:var(--pagination-text-range-label);overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.pagination{justify-content:flex-end}.pagination,.pagination-button{display:flex}.pagination-button{fill:var(--pagination-text-default);align-items:center;background-color:transparent;border-width:0;color:var(--pagination-text-default);cursor:pointer;height:48px;justify-content:center;outline:2px solid transparent;outline-offset:2px;width:48px}.pagination-button-disabled{fill:var(--pagination-text-disabled);color:var(--pagination-text-disabled);cursor:not-allowed;pointer-events:none}.pagination-notation{color:var(--pagination-text-default);font-family:var(--copytext-font-family);font-size:var(--copytext-font-size-small-noctx);font-weight:400;line-height:var(--copytext-line-height-small-noctx);line-height:24px}@media (min-width:768px){.pagination-wrapper{flex-wrap:wrap;gap:16px;justify-content:flex-end}.tablet\\:flex-wrap{flex-wrap:wrap}.tablet\\:gap-\\[16px\\]{gap:16px}}@media screen and (min-width:768px){.row-info-slots-wrapper .row-info-slots-separator{border-left:1px solid var(--pagination-stroke-separator)!important;margin-left:24px;margin-right:12px}.row-info-slots-wrapper ::slotted([slot=dropdown-range-label]){align-items:center;display:flex;font-size:var(--copytext-font-size-small-noctx);height:48px;line-height:var(--copytext-line-height-small-noctx);margin-left:var(--spacing-0);padding-left:12px;padding-right:12px}}@media screen and (min-width:1280px){.pagination-wrapper{flex-wrap:nowrap}.pagination-wrapper.has-row-info-slots{justify-content:space-between}}.static{position:static}.ml-\\[-16px\\]{margin-left:-16px}.w-full{width:100%}.resize{resize:both}.flex-nowrap{flex-wrap:nowrap}@media (min-width:768px){.tablet\\:w-auto{width:auto}.tablet\\:gap-0{gap:var(--spacing-0)}}@media (min-width:1280px){.desktop\\:ml-0{margin-left:var(--spacing-0)}.desktop\\:flex-nowrap{flex-wrap:nowrap}.desktop\\:justify-start{justify-content:flex-start}}.block{display:block}", qt = Ft, P = {
  de: bt,
  en: wt,
  es: yt,
  fr: _t,
  it: kt,
  ja: jt,
  pt: Jt,
  ru: Ut,
  zh: At,
  ko: Bt,
  nl: Ct,
  pl: Tt,
  tr: Nt
}, Ht = class {
  constructor(e) {
    Pt(this, e), this.buttonFirst = l(this, "lhButtonFirst", 7), this.buttonPrev = l(this, "lhButtonPrev", 7), this.buttonNext = l(this, "lhButtonNext", 7), this.buttonLast = l(this, "lhButtonLast", 7), this.pageChange = l(this, "lhChangeToPage", 7), this.change = l(this, "lhChange", 7), this.languageCode = "", this.supportedLangs = ["de", "en", "es", "fr", "it", "ja", "ko", "nl", "pl", "pt", "ru", "tr", "zh"], this.clickButtonFirst = (t) => {
      this.baseUrl && this.anchorIsDeactivated && t.preventDefault(), t == null || t.stopPropagation(), this.buttonFirst.emit(), this.change.emit({ value: 1 });
    }, this.clickButtonPrev = (t) => {
      this.baseUrl && this.anchorIsDeactivated && t.preventDefault(), t == null || t.stopPropagation(), this.buttonPrev.emit(), this.change.emit({ value: this.currentPage - 1 });
    }, this.clickButtonNext = (t) => {
      this.baseUrl && this.anchorIsDeactivated && t.preventDefault(), t == null || t.stopPropagation(), this.buttonNext.emit(), this.change.emit({ value: this.currentPage + 1 });
    }, this.clickButtonLast = (t) => {
      this.baseUrl && this.anchorIsDeactivated && t.preventDefault(), t == null || t.stopPropagation(), this.buttonLast.emit(), this.change.emit({ value: this.lastPage });
    }, this.calculatePaginationData = (t, i) => {
      this.isSwitchToPreviousButtonDisabled = t <= 1, this.isSwitchToNextButtonDisabled = t >= this.lastPage;
      const s = i ? 3 : 5;
      let r = i ? 3 : 5;
      const n = Math.floor(s / 2);
      let o = Math.max(t - n, 1);
      const g = Math.max(n - (this.lastPage - t), 0);
      o = Math.max(o - g, 1), r = this.lastPage - o + 1, this.pages = this.fillPageArray(o, Math.min(r, s));
    }, this.anchorIsDeactivated = !0, this.baseUrl = null, this.currentPage = 1, this.baseUrlTransformer = (t) => t, this.lastPage = null, this.wcag = "AAA", this.currentPageState = 0, this.pages = [], this.isSwitchToNextButtonDisabled = !1, this.isSwitchToPreviousButtonDisabled = !1, this.isMobile = !1, this.i18nState = void 0;
  }
  watchLastPage() {
    this.watchCurrentPage();
  }
  watchCurrentPage() {
    this.lastPage = this.lastPage && this.lastPage >= 1 ? this.lastPage : 1, this.currentPageState = this.currentPage <= this.lastPage && this.currentPage >= 1 ? this.currentPage : 1, this.calculatePaginationData(this.currentPageState, this.isMobile);
  }
  windowResize() {
    const e = ut() === "isMobile";
    this.isMobile !== e && (this.calculatePaginationData(this.currentPageState, e), this.isMobile = e);
  }
  /**
   * Returns the current page (one-indexed).
   */
  async getCurrentPage() {
    return this.currentPageState;
  }
  /**
   * Returns the last page (one-indexed).
   */
  async getLastPage() {
    return this.lastPage;
  }
  fillPageArray(e, t) {
    const i = [];
    for (let s = 0; s < t; s++)
      i.push(e + s);
    return i;
  }
  createAnchorHrefURL(e) {
    if (this.baseUrl === null)
      return null;
    const t = e - 1;
    return this.baseUrlTransformer(this.baseUrl, t);
  }
  listenChangeToPage(e) {
    this.pageChange.emit(e.detail), this.change.emit({ value: e.detail });
  }
  connectedCallback() {
    const e = (t) => {
      const i = dt("lang", t);
      this.languageCode = "en", i && this.supportedLangs.includes(i) && (this.languageCode = i), this.i18nState = h.resolveJsonBasedOnLanguage(this.languageCode, P);
    };
    this.observer = new MutationObserver(e), this.observer.observe(document.documentElement, { attributes: !0 });
  }
  componentWillLoad() {
    this.lastPage = this.lastPage && this.lastPage >= 1 ? this.lastPage : 1, this.currentPageState = this.currentPage <= this.lastPage && this.currentPage >= 1 ? this.currentPage : 1, this.windowResize(), this.calculatePaginationData(this.currentPageState, this.isMobile);
    const e = this.hostElement.querySelector('[slot="dropdown"]'), t = this.hostElement.querySelector('[slot="dropdown-range-label"]');
    this.hasDropdownSlot = e !== null, this.hasDropdownRangeLabelSlot = t !== null, this.hasRowInfoSlots = this.hasDropdownSlot || this.hasDropdownRangeLabelSlot, this.languageCode = "en", document.documentElement.lang && this.supportedLangs.includes(document.documentElement.lang) && (this.languageCode = document.documentElement.lang), this.i18nState = h.resolveJsonBasedOnLanguage(this.languageCode, P);
  }
  disconnectedCallback() {
    this.observer.disconnect();
  }
  render() {
    const e = {
      "pagination-wrapper": !0,
      "has-row-info-slots": this.hasRowInfoSlots
    }, t = {
      "row-info-slots-separator": !0
    }, i = {
      "pagination-button": !0,
      "pagination-button-disabled": this.isSwitchToPreviousButtonDisabled,
      "pagination-button-prev": !0
    }, s = {
      "pagination-button": !0,
      "pagination-button-disabled": this.isSwitchToNextButtonDisabled,
      "pagination-button-next": !0
    }, r = (n, o, g, ht, c, p = "") => this.baseUrl && this.baseUrl.length > 0 ? a("a", { href: this.createAnchorHrefURL(ht), class: g, onClick: o ? void 0 : n, "aria-label": p, "aria-disabled": o }, a("patternlib-icon", { iconName: c, size: "24px" })) : a("button", { class: g, onClick: n, disabled: o, "aria-disabled": o, "aria-label": p }, a("patternlib-icon", { iconName: c, size: "24px" }));
    return a("div", { key: "8ac066cf482d8e6ef21c359ee2372a3a31c35e21", class: e }, this.hasRowInfoSlots && a("div", { key: "65e36a5b1406a9761c89b8249ffe7c8082ce69ef", class: "row-info-slots-wrapper flex flex-wrap desktop:flex-nowrap justify-center desktop:justify-start gap-[10px] tablet:gap-0 truncate text-copy-small-uniform" }, this.hasDropdownSlot && a("div", { key: "389eeb2b05c39342eb62a51c2d3efefb7baa66d8", class: "w-full tablet:w-auto flex flex-nowrap justify-center desktop:justify-start items-center ml-[-16px] desktop:ml-0" }, a("slot", { key: "15723b5c79a0c9c00fe67eefacd62fa935c5173a", name: "dropdown" }), a("slot", { key: "6206572f1580c24d5276da8609e6a823912496a5", name: "dropdown-label" })), this.hasDropdownSlot && this.hasDropdownRangeLabelSlot && a("div", { key: "3c179d19a15ebfc370cc1a309974f05fecf1ef58", class: t }), this.hasDropdownRangeLabelSlot && a("slot", { key: "5cbe2d4acf55ecc6d8b2c540425619a21debbc5c", name: "dropdown-range-label" })), (!this.hasRowInfoSlots || this.lastPage > 1) && a("div", { key: "1459dd1de141e24b893ff4dfeca708401359c7ee", class: "pagination" }, r(this.clickButtonFirst, this.isSwitchToPreviousButtonDisabled, i, 1, "arrow-first-page", this.i18nState.firstPage), r(this.clickButtonPrev, this.isSwitchToPreviousButtonDisabled, i, Math.max(this.currentPage - 1, 1), "arrow-left", this.i18nState.previousPage), a("div", { key: "48b935984b7a5ebb3a077218775b8b82553998aa", class: "pagination-pages pagination-notation" }, this.pages.map((n) => a("patternlib-pagination-item", { label: n, href: this.createAnchorHrefURL(n), anchorIsDeactivated: this.anchorIsDeactivated, active: n === this.currentPageState, wcag: this.wcag }))), r(this.clickButtonNext, this.isSwitchToNextButtonDisabled, s, Math.min(this.currentPage + 1, this.lastPage), "arrow-right", this.i18nState.nextPage), r(this.clickButtonLast, this.isSwitchToNextButtonDisabled, s, this.lastPage, "arrow-last-page", this.i18nState.lastPage)));
  }
  get hostElement() {
    return ft(this);
  }
  static get watchers() {
    return {
      lastPage: ["watchLastPage"],
      currentPage: ["watchCurrentPage"]
    };
  }
};
Ht.style = qt;
export {
  Ht as patternlib_pagination
};
